import Button, { ButtonProps } from "../Button";
import React from "react";
import Card from "../Card";
import { isMobile } from "@/utils/is-mobile";
import { cn } from "@networx/utils/tailwind/cn";
import { SlotsToClasses } from "@nextui-org/react";

export default function StepLayout({
  children, title, subtitle, buttonProps, onClickPrev,
  hideDivider, variant, classNames, fullWidthNextButton
}: Props) {
  const isMobileView = isMobile();

  return isMobileView ? (
    <div
      className="flex flex-col justify-between w-full flex-1"
    >
      <div className={cn("flex flex-col gap-4 w-full pt-[20px] flex-1 min-h-0 overflow-auto mb-8 mt-2", classNames?.headerWrapper)}>
        <div className={cn("flex flex-col gap-[10px] w-full", classNames?.headerTitleWrapper)}>
          <span className={cn("text-[20px] text-center sm:text-auto leading-[1.2] !text-[#435b6c] font-bold", classNames?.title)}>{title}</span>
          <span className={cn("text-[#595959] text-[16.8px] text-center sm:text-auto", classNames?.subtitle)}>{subtitle}</span>
        </div>

        <div className={cn("flex flex-col gap-4 w-full px-[20px] flex-1", classNames?.children)}>
          {children}
        </div>
      </div>
      <div className="bg-content1 border-t-small border-default w-full py-5 px-[9px] flex items-center justify-center">
        <div className={cn(fullWidthNextButton ? "w-full" : "max-w-[235px]", "flex items-center justify-center")}>
          {onClickPrev &&
            <Button
              onClick={onClickPrev}
              variant="clear"
              className="flex-1"
            >
              Previous
            </Button>
          }
          <Button
            {...buttonProps}
            className={cn("flex-1 rounded-[3px]", buttonProps?.className)}
          >
            {buttonProps?.label || buttonProps?.children || "Next"}
          </Button>
        </div>
      </div>
    </div>
  ) : (
    <Card
      header={title}
      subtitle={subtitle}
      classNames={{
        shadow: {
          header: "text-[#435b6c] text-[24px] leading-[28px]",
          base: "pt-[40px] w-full max-w-[680px] min-h-[342px] border-none shadow-[0_4px_12px_0_rgba(0,_0,_0,_0.1)]",
          content: classNames?.children,
          footerWrapper: "mt-4",
        },
        bordered: {
          header: ["text-[#435b6c]", classNames?.title],
          headerWrapper: classNames?.headerWrapper,
          subtitle: classNames?.subtitle,
          base: ["w-full max-w-[920px]", classNames?.cardBase],
          content: classNames?.children,
          footer: "max-h-[44px]"
        }
      }[variant ?? "bordered"]}
      footerProps={{
        hideDivider,
        previousButton: !onClickPrev ? null : undefined,
        previousButtonProps: {
          onClick: onClickPrev,
        },
        nextButtonProps: {
          ...buttonProps,
          children: buttonProps?.label || buttonProps?.children,
        }
      }}
    >
      {children}
    </Card>
  );
}


interface Props {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  buttonProps?: {
    label?: string;
  } & ButtonProps;
  children: React.ReactNode;
  onClickPrev?: () => void;
  hideDivider?: boolean;
  variant?: "shadow" | "bordered";
  classNames?: SlotsToClasses<"title" | "subtitle" | "headerWrapper" | "headerTitleWrapper" | "cardBase" | "children">;
  fullWidthNextButton?: boolean;
}
